export default "__VITE_ASSET__BzZCSyjZ__"